/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * EnterpriseIcon - Auto-generated from icon.js
 */
export const EnterpriseIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M3 6C3 4.89543 3.89543 4 5 4H12C13.1046 4 14 4.89543 14 6V20H3V6Z" stroke="black" />
		<path d="M14 7H19C20.1046 7 21 7.89543 21 9V20H14V7Z" stroke="black" />
		<path d="M17 10H18" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M10 10H11" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M6 10H7" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M10 7H11" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M6 7H7" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M17 13H18" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M10 13H11" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M6 13H7" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M17 16H18" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M10 16H11" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M6 16H7" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export default EnterpriseIcon;
